import styled from 'styled-components';
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import { PopoverContainer } from '@deprecated-ui/header';
import color from '@deprecated-ui/_style/color';

const ButtonTrading = styled(Flex)`
  position: relative;
  align-items: center;
  border-left: 1px solid ${color.lowgray};
  justify-content: ${({ minimize = false }) =>
    minimize ? 'space-between' : 'space-around'};
  padding: ${({ minimize = false }) => (!minimize ? '16px 0' : '0 16px')};
  flex-direction: ${({ minimize = false }) => (!minimize ? 'column' : 'row')};
  width: ${({ minimize = false }) => (!minimize ? '110px' : '145px')};
  height: ${({ minimize = false }) => (!minimize ? '101px' : '60px')};
  cursor: pointer;

  ::after {
    content: '';
    position: absolute;
    width: 100%;
    top: 100%;
    right: 0;
    height: ${({ isActive = false }) => (isActive ? '1px' : 0)};
    background: ${color.light};
    z-index: 2;
  }
`;

const TradingMenuTitle = styled(Text)`
  padding: 0 15px;
  line-height: 24px;
  font-weight: 700;
  font-size: 14px;
  color: ${color.primary};
`;

const TradingMenuItemContainer = styled(Flex)`
  align-items: center;
  padding: 0 15px;
  cursor: pointer;
  :hover {
    background: ${color.downgray};
    p,
    p::before {
      color: ${color.primary};
    }
  }
`;

const TradeAreaContent = styled.div`
  padding: 8px 6px;
  width: 250px;
  background-color: white;
  padding: 10px 0;
  border-bottom: 1px solid ${color.lowgray};
  :last-child {
    border-bottom: none;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border-left: 1px solid ${color.downgray};
  border-bottom: 1px solid ${color.downgray};
`;

const PopoverContainerFlex = styled(PopoverContainer)`
  position: absolute;
  top: 100%;
  right: 0;
  display: flex;
`;

const PopoverContainerBlock = styled(PopoverContainerFlex)`
  display: block;
`;

const NavigationMobile = styled(Flex).attrs({
  direction: 'column',
  py: '15px',
  align: 'center',
  justify: 'center',
})`
  border-top: 1px solid ${color.downgray};
  border-right: 1px solid ${color.downgray};
`;

export {
  ButtonTrading,
  TradingMenuTitle,
  TradingMenuItemContainer,
  TradeAreaContent,
  Grid,
  PopoverContainerBlock,
  NavigationMobile,
};
